import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const assignFeedback = createAsyncThunk(
  'kb/feedback/assign',
  async (assignData, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;

      const response = await axios.post(
        `${ROOT_URL}/kb/feedback/assign`, // Endpoint for assigning feedback
        assignData,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error assigning feedback:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
};

const assignFeedbackSlice = createSlice({
  name: 'assignFeedback',
  initialState,
  reducers: {
    resetAssignFeedbackState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(assignFeedback.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(assignFeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(assignFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }
});

export const { resetAssignFeedbackState } = assignFeedbackSlice.actions;
export default assignFeedbackSlice.reducer;